import React from 'react';
import { TanstackTableColumns } from '../../../../components/TanstackTable/types';
import { SettlementItemByBrand } from '../../types/columns';
import { MainImage, StyledAnchor, ButtonLikeLinkStyle } from './styles';
import formatPhoneNumber from '../../../../lib/utils/common/formatPhoneNumber';

const columns: TanstackTableColumns<SettlementItemByBrand> = [
  {
    id: 'id',
    accessorKey: 'id',
    header: '상세보기',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell) => (
      <ButtonLikeLinkStyle to={`/store/detail/${cell.getValue()}?tabKey=2`}>상세보기</ButtonLikeLinkStyle>
    ),
  },
  {
    id: 'mainImageUrl',
    accessorKey: 'mainImageUrl',
    header: '대표이미지',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): JSX.Element | string => {
      const mainImageUrl = cell.getValue();
      return mainImageUrl && typeof mainImageUrl === 'string' ? <MainImage src={mainImageUrl} /> : '-';
    },
  },
  {
    id: 'brandId',
    accessorKey: 'brandId',
    header: '브랜드 ID',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): JSX.Element => {
      return (
        <StyledAnchor target="_blank" href={`/store/detail/${cell.getValue()}?tabKey=0`} rel="noreferrer noopener">
          {cell.getValue()}
        </StyledAnchor>
      );
    },
  },
  {
    id: 'brandName',
    accessorKey: 'brandName',
    header: '브랜드 명',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    accessorKey: 'status',
    header: '상태',
    size: 80,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    accessorKey: 'confirmDate',
    header: '입점일자',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell) => cell.getValue() || '-',
  },
  {
    accessorKey: 'accountHolder',
    header: '예금주',
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    accessorKey: 'accountNumber',
    header: '계좌번호',
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    accessorKey: 'bankName',
    header: '은행',
    size: 100,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    accessorKey: 'phone',
    header: '판매자 연락처',
    size: 110,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      const phone = cell.getValue();
      return typeof phone === 'string' ? formatPhoneNumber(phone) : '-';
    },
  },
  {
    accessorKey: 'periodType',
    header: '브랜드상품 정산 주기 타입',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell) => cell.getValue() || '-',
  },
  {
    accessorKey: 'enterIsPgFeeUsed',
    header: '입점상품 PG 수수료 여부',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return cell.getValue() ? 'ON' : 'OFF';
    },
  },
  {
    accessorKey: 'enterAmondzFeeRate',
    header: '입점상품 아몬즈 수수료(%)',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'enterMarketingFeeRate',
    header: '입점상품 마케팅 수수료(%)',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'enterFulfillmentFeeRate',
    header: '입점상품 풀필먼트 수수료(%)',
    size: 190,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'incomeIsPgFeeUsed',
    header: '입고상품 PG 수수료 여부',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return cell.getValue() ? 'ON' : 'OFF';
    },
  },
  {
    accessorKey: 'incomeAmondzFeeRate',
    header: '입고상품 아몬즈 수수료(%)',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'incomeMarketingFeeRate',
    header: '입고상품 마케팅 수수료(%)',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'incomeFulfillmentFeeRate',
    header: '입고상품 풀필먼트 수수료(%)',
    size: 190,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'consignmentIsPgFeeUsed',
    header: '위탁생산 PG 수수료 여부',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return cell.getValue() ? 'ON' : 'OFF';
    },
  },
  {
    accessorKey: 'consignmentAmondzFeeRate',
    header: '위탁생산 아몬즈 수수료(%)',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'consignmentMarketingFeeRate',
    header: '위탁생산 마케팅 수수료(%)',
    size: 180,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
  {
    accessorKey: 'consignmentFulfillmentFeeRate',
    header: '위탁생산 풀필먼트 수수료(%)',
    size: 190,
    enableSorting: false,
    enableColumnFilter: false,
    cell: (cell): string => {
      if (typeof cell.getValue() === 'undefined') {
        return '-';
      }

      return `${cell.getValue()}`;
    },
  },
];

export default columns;
